export default {
  __html:
    '<path fill="none" fill-rule="evenodd" stroke-linecap="round" stroke="currentColor" stroke-linejoin="round" stroke-width="2" d="M1 1.055L5.972 6 11 1"/>'
}
